(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    const syncDrawerFiltersState = () => {
      if (window.innerWidth > 749) return;

      const drawer = document.querySelector('#filters-drawer');
      if (!drawer) return;

      const groups = drawer.querySelectorAll('.drawer-filter-group');

      groups.forEach((group) => {
        const details = group.querySelector('details');
        if (!details) return;

        const hasActive = group.classList.contains('drawer-filter-group--active');

        if (hasActive) {
          details.setAttribute('open', '');
        } else {
          details.removeAttribute('open');
        }
      });
    };

    syncDrawerFiltersState();

    document.addEventListener('click', (event) => {
      const openBtn = event.target.closest('[on\\:click="#filters-drawer/showDialog"]');
      if (!openBtn) return;

      requestAnimationFrame(() => {
        setTimeout(syncDrawerFiltersState, 0);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
